import React, { createContext, useState, useEffect } from "react";


export const ColorContext = createContext();

export const ColorProvider = ({ children }) => {
  
  const [bgColor, setBgColor] = useState(() => localStorage.getItem("navColor") || "blue");

  useEffect(() => {
    localStorage.setItem("navColor", bgColor);
  }, [bgColor]);

  return (
    <ColorContext.Provider value={{ bgColor, setBgColor }}>
      {children}
    </ColorContext.Provider>
  );
};
